import { MenuItem, type MenuItemProps } from '@affine/component';

interface WikiActionProps extends MenuItemProps {
  label: string;
}

export const WikiAction = ({ label, ...menuItemProps }: WikiActionProps) => {
  return <MenuItem {...menuItemProps}>{label}</MenuItem>;
};
